export function isFlagOn (value) {
  return value === 1 || value === '1'
}

export function isCoursePaid (row) {
  return !!(row && isFlagOn(row.isPay))
}

export function isOrderPaid (order) {
  return !!(order && isFlagOn(order.payStatus))
}

export function canPayOrder (order) {
  return !!(order && isFlagOn(order.canPay))
}

export function orderTypeText (type) {
  if (type === 1 || type === '1') return '按考生'
  if (type === 2 || type === '2') return '按课程'
  return '--'
}

export function findEnrolledCourse (records, courseId) {
  const id = courseId === null || courseId === undefined ? '' : String(courseId)
  if (!id || !Array.isArray(records)) return null
  return records.find((item) => String(item.courseId) === id) || null
}

export async function isEnrolledCoursePaid (http, examConfigId, courseId) {
  const res = await http.get('/student/pc/chooseCourse', {
    examConfigId,
    size: '9999'
  })
  const records = Array.isArray(res) ? res : ((res && res.records) || [])
  return isCoursePaid(findEnrolledCourse(records, courseId))
}

export function confirmUnpaid (vm, message) {
  return vm.$confirm(message, '提示', {
    confirmButtonText: '去缴费',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(() => {
    vm.$router.push({ path: '/main/registration' })
  }).catch(() => {})
}

export async function ensureEnrolledPaid (vm, examConfigId, courseId, message) {
  if (!examConfigId) {
    vm.$message.error('请选择考次')
    return false
  }
  try {
    const paid = await isEnrolledCoursePaid(vm.$http, examConfigId, courseId)
    if (paid) return true
  } catch (error) {
    return false
  }
  await confirmUnpaid(vm, message)
  return false
}

export function toQrSrc (data) {
  if (data === null || data === undefined) return ''
  const text = String(data).trim()
  if (!text) return ''
  if (
    text.startsWith('data:image') ||
    text.startsWith('http://') ||
    text.startsWith('https://') ||
    text.startsWith('blob:')
  ) {
    return text
  }
  return `data:image/png;base64,${text}`
}
